(function() {
  'use strict';
  angular.module('myConsultApp')
    .constant('DefaultConstant', {
      'isValidEmail': /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    })
    .constant('DateDelaySlots', {
      slots : [
        {value:0, name:'Immediately'},
        {value:1, name:'1 day'},
        {value:2, name:'2 days'},
        {value:3, name:'3 days'},
        {value:4, name:'4 days'},
        {value:5, name:'5 days'},
        {value:6, name:'6 days'},
        {value:7, name:'7 days'},
        {value:8, name:'8 days'},
        {value:9, name:'9 days'},
        {value:10, name:'10 days'},
        {value:11, name:'11 days'},
        {value:12, name:'12 days'},
        { value : 13, name: '13 days' },
        { value : 14, name: '14 days' },
        { value : 15, name: '15 days' },
        { value : 16, name: '16 days' },
        { value : 17, name: '17 days' },
        { value : 18, name: '18 days' },
        { value : 19, name: '19 days' },
        { value : 20, name: '20 days' },
        { value : 21, name: '21 days' },
        { value : 22, name: '22 days' },
        { value : 23, name: '23 days' },
        { value : 24, name: '24 days' },
        { value : 25, name: '25 days' },
        { value : 26, name: '26 days' },
        { value : 27, name: '27 days' },
        { value : 28, name: '28 days' },
        { value : 29, name: '29 days' },
        { value : 30, name: '30 days' }
        ]
    })
    .constant('DateObj', {
      'months': [
        { value : '0', name: 'January' },
        { value : '1', name: 'February' },
        { value : '2', name: 'March' },
        { value : '3', name: 'April' },
        { value : '4', name: 'May' },
        { value : '5', name: 'June' },
        { value : '6', name: 'July' },
        { value : '7', name: 'August' },
        { value : '8', name: 'September' },
        { value : '9', name: 'October' },
        { value : '10', name: 'November' },
        { value : '11', name: 'December' }
       ],
      'days': [
        { value : '1', name: '01' },
        { value : '2', name: '02' },
        { value : '3', name: '03' },
        { value : '4', name: '04' },
        { value : '5', name: '05' },
        { value : '6', name: '06' },
        { value : '7', name: '07' },
        { value : '8', name: '08' },
        { value : '9', name: '09' },
        { value : '10', name: '10' },
        { value : '11', name: '11' },
        { value : '12', name: '12' },
        { value : '13', name: '13' },
        { value : '14', name: '14' },
        { value : '15', name: '15' },
        { value : '16', name: '16' },
        { value : '17', name: '17' },
        { value : '18', name: '18' },
        { value : '19', name: '19' },
        { value : '20', name: '20' },
        { value : '21', name: '21' },
        { value : '22', name: '22' },
        { value : '23', name: '23' },
        { value : '24', name: '24' },
        { value : '25', name: '25' },
        { value : '26', name: '26' },
        { value : '27', name: '27' },
        { value : '28', name: '28' },
        { value : '29', name: '29' },
        { value : '30', name: '30' },
        { value : '31', name: '31' }
      ],
      'years': [
        { value : '2017', name: '2017' },
        { value : '2016', name: '2016' },
        { value : '2015', name: '2015' },
        { value : '2014', name: '2014' },
        { value : '2013', name: '2013' }
      ]
    });
}());
